$(function() {
  var open = $(".articles_head_footer .open"),
        close = $(".articles_head_footer .close");
        open.click(function(e) {
            e.preventDefault(), open.hide(), close.show(), close.css("display", "inline-block"), $(" .articles_head_body").slideDown()
        }), close.click(function(e) {
            e.preventDefault(), close.hide(), open.show(), $(" .articles_head_body").slideUp()
        })
})